import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from './../../../shared/shared.module';
import { NgxMaskModule } from 'ngx-mask';

import { FichaCadastroResultadoParcialComponent } from './ficha-cadastro-resultado-parcial.component';
import { SeguroComponent } from './seguro/seguro.component';
import { SliderRetornoComponent } from './seguro/slider-retorno/slider-retorno.component';
import { ValorFinanciadoComponent } from './valor-financiado/valor-financiado.component';
import { SliderValorFinanciadoComponent } from './valor-financiado/slider-valor-financiado/slider-valor-financiado.component';
import { VeiculoComponent } from './veiculo/veiculo.component';
import { ParcelaComponent } from './parcela/parcela.component';
import { SaibaMaisModule } from './../../../shared/saiba-mais/saiba-mais.module';
import { ModaisModule } from './../../../shared/modais/modais.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AlterarValorComponent } from './valor-financiado/alterar-valor/alterar-valor.component';
import { ModalEditVeiculoComponent } from './modal-edit-veiculo/modal-edit-veiculo.component';
import { PipesModule } from '../../../pipes/pipes.module';
import { DirectivesModule } from '../../../directives/directives.module';
import { SegurosService } from '../../seguros.service';
import { ParcelaFlexivelComponent } from './parcela-flexivel/parcela-flexivel.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    PipesModule,
    DirectivesModule,
    SaibaMaisModule,
    ModaisModule,
    NgxMaskModule.forRoot(),
    ModalModule.forRoot(),
  ],
  declarations: [
    FichaCadastroResultadoParcialComponent,
    SeguroComponent,
    SliderRetornoComponent,
    ValorFinanciadoComponent,
    SliderValorFinanciadoComponent,
    VeiculoComponent,
    ParcelaComponent,
    AlterarValorComponent,
    ModalEditVeiculoComponent,
    ParcelaFlexivelComponent,
  ],
  exports: [
    FichaCadastroResultadoParcialComponent,
    SliderValorFinanciadoComponent,
    SliderRetornoComponent,
    ValorFinanciadoComponent,
    AlterarValorComponent
  ],
  providers:[
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    SegurosService
  ],
  entryComponents: [AlterarValorComponent, ModalEditVeiculoComponent]
})
export class ResultadoParcialModule { }
